import { atom } from "@reatom/framework";
import { type ProductControllerSearchSortByEnum } from "definitions/product-storage";

export interface SortState {
  type: ProductControllerSearchSortByEnum;
}

export const sortAtom = atom<SortState | null>(null, "sortAtom");
